<div class="flxClmn">
    <div class="page-title-container flxRow">
        <div class="flxClmn-center f-1-0">
            <div class="page-title-inner-container flxRow">
                <span class="page-title">User Management</span>
                <!--Information modal-->
                <more-info-c>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Actions</span>
                        <br/>
                        <span><b>{{dic.CONSTANTS.userActions.resendInvitation}}</b> - resend the invitation email to the user</span>
                        <span><b>Block/Unblock User</b> - a blocked user will not be able to access their account</span>
                        <span><b>{{dic.CONSTANTS.userActions.remove}}</b> - remove the user from your plan</span>
                        <span><b>Enable/Disable Login MFA</b> - when enabled, the user will be required to perform multi-factor authentication when logging in</span>
                        <span><b>Modify Permissions</b> - grant or revoke admin and reviewer permissions for the user</span>
                        <span><b>{{dic.CONSTANTS.userActions.moveToOtherAdmin}}</b> - move the user to another admin's plan</span>
                        <span><b>{{dic.CONSTANTS.userActions.allocatePlan}}</b> - allocate a new plan to the user, who will become the plan's admin</span>
                        <span><b>{{dic.CONSTANTS.userActions.modifyResources}}</b> - update the admin plan's expiration, emails, storage, and licenses</span>
                        <span><b>{{dic.CONSTANTS.userActions.removePlan}}</b> - remove the admin's plan and set them as a user</span>
                    </div>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Status</span>
                        <br/>
                        <span><b style="color: green;">Active</b> - The user is actively sending outbound emails through your Trustifi plan</span>
                        <span><b style="color: darkorange;">Invitation Sent</b> - An invitation has been sent to add this user to your Trustifi plan, and they haven't completed the onboarding process yet</span>
                        <span><b style="color: darkorange;">Inactive</b> - The user has not sent any emails through your Trustifi plan in the past 60 days</span>
                        <span><b style="color: red;">Blocked</b> - The user has been blocked. They cannot sign into their Trustifi account or send emails through your plan</span>
                        <span><b style="color: red;">Plan Blocked</b> - The user's plan has been blocked, all users under this plan cannot sign into their Trustifi account or send emails through this plan</span>
						<span><b style="color: red;">Risky for 24 Hours</b> - The user has been temporarily marked as "Risky". All emails sent by this user will undergo enhanced threat scans</span>
						<span><b style="color: red;">Blocked for 24 Hours</b> - The user has been temporarily blocked for 24 hours. They cannot sign into their Trustifi account or send emails through your plan during this period</span>
						<span><b style="color: red;">Expired</b> - The plan's expiration date has passed and needs to be renewed. If the plan isn't renewed on time, it could be automatically blocked</span>
					</div>
                </more-info-c>
            </div>
            <div class="page-subtitle-container" style="display: flex; gap: 5px;">
				<span class="page-subtitle">Users and admins in your plan</span>
				<!--CC: technician (managed plans only) on the own plan - explain what this page is for them-->
					<span style="background: var(--ui-surface-2); border-radius: 999px; padding: 2px 10px; font-size: 12px; font-weight: 600; color: var(--ui-text); margin-left: 8px; white-space: nowrap;"
						  *ngIf="userManagementLoaded && mainPlanAdmin">
					{{mainPlanAdmin.alloc_plan_id?.shared_plan?.used_users || 0}} of {{mainPlanAdmin.alloc_plan_id?.shared_plan?.allowed_users  || 0}} licenses used
				</span>
            </div>
        </div>
        <div class="control-and-info-icons flxRow"></div>
    </div>
    <div class="page-inner-content-holder no-scroll flxClmn bs-enabled">
		<!--CC: technician (managed plans only) on the own plan - explain what this page is for them-->
		<div class="flxRow hSpace05 bs-enabled" style="align-items: baseline; padding-bottom: 4px;" *ngIf="userInfo?.managed_plans_only && gs.controlAdmin?.email === userInfo?.email">
			<i class="far fa-info-circle text-info"></i>
			<span class="text-muted fw-500">Technician: your admin permissions apply to managed plans only. Create new plans here, and use the tenant selector at the top to manage a plan.</span>
		</div>
		<!--users table-->
		<trustifi-table-c #usersTableEl
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="usersList"
			[headers]="_.compact([
				 usersListView === dic.CONSTANTS.userMgmntListViews.company && {text:'Company Name', sortKey:'companyName'},
				 usersListView === dic.CONSTANTS.userMgmntListViews.domains && {text:'Domain Name', sortKey:'domainName'},
				 {text:'Name', sortKey:'name'},
				 {text:'Email', sortKey:'email_display'},
				 {text:'Status', sortKey:'status', width: '150px'},
				 {text:'Permissions', sortKey: 'user_role_display'},
				 isPartnerAdmin && {text:'Company Name', sortKey: 'company_name_display'},
			 ])"
			[cellsPrototype]="_.compact([
				(usersListView === dic.CONSTANTS.userMgmntListViews.company || usersListView === dic.CONSTANTS.userMgmntListViews.domains) && {html: 'companyOrDomainNameCell', overflowOutside: true},
				{html: 'nameCell'},
				{html: 'emailAddressCell'},
				{html: 'statusCell'},
				{html: 'RoleCell'},
				isPartnerAdmin && {html: 'companyNameCell'},
			])"
			[bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectMultipleUsersAction,
				initBulkActionsFunction: showMultipleUsersActions,
				showInRed: {enable: true, terms: ['Remove User']}
			}"
			[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectUserAction,
				initActionsFunction: showUserActions,
			}"
			(searchFunction)="searchUser($event.searchTerm, $event.activeFilters)"
			[filterData]="filterData"
			[subRowOptions]="{
				recursionKey: 'planUsers',
				allowActions: true
			}"
			[options]="{
				itemsNameSingular: 'user',
				exportToCsvFunction: exportUsersCsv,
				refreshFunction: getUsersOfSharedPlan,
				defaultSortKey: 'role_priority',
				loadingTableFlag: loadingUsersInProcess,
				itemUniqueIdentifier: '_id',
				changeTableViewMenu: {
					all: {label: 'View Per User', action: updateListView},
					company: {label: 'View Per Company', action: updateListView},
					domains: {label: 'View Per Domain', action: updateListView},
				}
			}"
		>

			<ng-template #customCells let-item let-cellId="cellId">
				<!--company/domain name cell-->
				<span *ngIf="cellId === 'companyOrDomainNameCell'">
					<div class="flex-row gap-1" style="align-items: center; cursor: pointer; position: absolute; left: 10px; top: 50%; transform: translateY(-50%);"
						 *ngIf="item.isCompanyTitleRecord"
						 (click)="toggleExpandItem(item, $event);">
						<i class="far fa-chevron-right" style="color: royalblue; transition: transform 0.15s ease-out; padding: 5px; padding-left: 0;"
						   *ngIf="item.planUsers && item.displayedCounter"
						   [ngStyle]="{'transform' : item.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}"></i>
						<span>{{item.companyName || item.domainName}}</span>
						<span style="opacity: 0.75;">({{item.displayedCounter}} user{{item.displayedCounter > 1 ? 's': ''}})</span>
						<span style="opacity: 0.55;">{{usersListView === dic.CONSTANTS.userMgmntListViews.company && mainPlanAdmin.company_name_display === item.companyName ? ' (yours)' : ''}}</span>
						<span style="opacity: 0.75;" *ngIf="usersListView === dic.CONSTANTS.userMgmntListViews.company && item.expired">|&nbsp;&nbsp;Expiration: {{item.expired | date:'MM/dd/yyyy'}}</span>
					</div>
				</span>
				<!--name cell-->
				<span *ngIf="cellId === 'nameCell'">
					<!--regular-->
					<div class="flxRow hSpace05" style="align-items: center; cursor: pointer;"
						 *ngIf="!item.isCompanyTitleRecord"
						 (click)="toggleExpandItem(item, $event);"
						 [ngStyle]="{'padding-left' : item.depth ? 15 + item.depth * 15 + 'px' : ''}">
						<img ngSrc="https://gravatar.com/avatar/{{this.gs.stringToSha256(item.email_display)}}?s=30&d=mp" style="border-radius: 50%;" width="30" height="30" alt="By Gravatar"/>
						<i class="far fa-chevron-right" style="color: royalblue; transition: transform 0.15s ease-out; padding: 5px; padding-left: 0;"
						   *ngIf="item.planUsers?.length"
						   [ngStyle]="{'transform' : item.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}"></i>
						<span style="vertical-align: middle;">{{item.name || 'N/A'}}</span>
					</div>
				</span>
				<!--email cell (job role shown as a secondary line)-->
				<span *ngIf="cellId === 'emailAddressCell'">
					<div class="flex-column">
						<div class="flex-row gap-1 align-items-center">
							<i class="far fa-key" *ngIf="item.preferences?.require_2fa?.strict" tooltip="Login MFA is enforced on this user"></i>
							<span [tooltip]="item.email_display">{{item.email_display}}</span>
						</div>
						<div class="flex-row gap-1 align-items-center text-muted" style="font-size: 11.5px;" *ngIf="item.job_title || item.is_executive">
							<i class="far fa-user-tie" *ngIf="item.is_executive" style="color: green;" tooltip="Executive Role"></i>
							<span class="ellipsis" [tooltip]="item.job_title">{{item.job_title}}</span>
						</div>
					</div>
				</span>
				<span *ngIf="cellId === 'statusCell'">
					<span *ngIf="!item.alloc_plan_id?.expired || withoutTime(item.alloc_plan_id.expired) >= withoutTime()"
						  [ngStyle]="item.status === dic.CONSTANTS.userInPlanStatus.active
						  ? {'color':'green'} : item.status === dic.CONSTANTS.userInPlanStatus.inactive || (item.status === dic.CONSTANTS.userInPlanStatus.invitationSent)
						  ? {'color':'darkorange'} : {'color':'red'}">
						{{item.status}}
					</span>
					<span style="color: red;" *ngIf="item.alloc_plan_id?.expired && withoutTime(item.alloc_plan_id.expired) < withoutTime()">
						Expired
					</span>
					<span *ngIf="item.is_relay"> (Relay)</span>
					<i class="far fa-question-circle opacity-75" *ngIf="item.statusToolip"
					   [tooltip]="item.statusToolip"></i>
				</span>
				<span *ngIf="cellId === 'RoleCell'">
					{{item.user_role_display}}
					<i style="margin-left: 5px;" class="fas fa-eye" *ngIf="item.read_only"
					   tooltip="Read only permissions"></i>
					<i style="margin-left: 5px;" class="far fa-user-cog" *ngIf="item.managed_plans_only && item.user_role === dic.CONSTANTS.userRole.subAdmin"
					   tooltip="Technician: admin permissions on managed plans only"></i>
					<i style="margin-left: 5px;" class="fas fa-search" *ngIf="item.user_reviewer"
					   tooltip="Reviewer of: {{item.user_reviewer}}"></i>
				</span>
				<span *ngIf="cellId === 'companyNameCell'" >
					<span *ngIf="!item.isCompanyTitleRecord">{{item.company_name_display || 'N/A'}}</span>
				</span>
			</ng-template>
			<div tableButtons>
				<div class="flex-row gap-1" *ngIf="userInfo">
					<btn-c style="width: 180px;" *ngIf="isPartnerAdmin"
						   endIcon="far fa-plus"
						   [isDisabled]="loadingUsersInProcess"
						   (action)="addActiveAdmin();">
						Create New Plan
					</btn-c>
					<btn-c style="width: 180px;"
						   endIcon="far fa-plus"
						   [isDisabled]="!mainPlanAdmin || loadingUsersInProcess"
						   (action)="addActiveUser();">
						Add Users
					</btn-c>
					<app-dropdown-c style="width: 180px;"
								  [isDisabled]="loadingUsersInProcess"
								  text="More"
								  [isLf]="true">
						<li (click)="openAccountConfigPopup();">
							Plan Security Settings
						</li>
						<li (click)="showGroups = true">
							Show Groups
						</li>
						<li (click)="getMailboxesAliases(true)">
							Show Aliases
						</li>
						<li (click)="openSuppressionPopup();">
							Suppression List
						</li>
					</app-dropdown-c>
				</div>
			</div>
		</trustifi-table-c>
	</div>

    <!--Add Users to Plan popup-->
    <popup-c *ngIf="addActiveUserPopup?.show"
           head="Add Users to Plan"
           (closeCb)="closePopupAndRemoveAllTags()"
           (confirmCb)="updateTemplateAndAddUsersToSharedPlan()"
           [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: stopActiveUserPopup}}"
           size="dynamic">
        <div class="flxClmn add-user-form f-1-0 vSpace3">
            <div class="admin-panel-row" (clickOutside)="contactAutocompleteData.showContacts = false">
                <label style="margin-right: 15px;">Email(s)</label>
                <div class="flxClmn vSpace05 w100 bs-enabled">
					<div class="flex-row gap-2 flex-wrap position-relative p-1 justify-content-start" style="border: solid 1px #cccccc;" (click)="focusNewUserInput()">
						<div class="flex-row align-items-center rounded-pill bg-light py-1 px-2 gap-2 cursor-pointer hvr-opacity"
							 style="font-size: 12px;" *ngFor="let newUser of users; let index = index; trackBy: gs.trackByIndex;"
							 (click)="$event.stopPropagation(); removeNewUser(index)">
							<span>{{newUser.name}}</span>
							<i class="zmdi zmdi-close-circle"></i>
						</div>
						<input type="text" id="adminContacts" #adminContacts
							   style="margin: 0; border: none; min-width: 200px;"
							   [(ngModel)]="addNewUserInputTxt"
							   autocomplete="off"
							   (keyup.enter)="confirmNewUserEmail(addNewUserInputTxt)">
						<auto-complete-menu [autoCompleteItems]="allContacts"
											[searchTerm]="addNewUserInputTxt"
											[inputElementRef]="adminContacts"
											searchByKeys="name,email"
											(onItemClick)="confirmNewUserFromContacts($event.item)">
							<ng-template #customListTemplate let-filteredItems>
								<li class="flxClmn vSpace05"
									tabindex="0"
									*ngFor="let contact of filteredItems"
									[highlightText]="addNewUserInputTxt"
									[isHighlightOn]="true"
									(keyup.enter)="confirmNewUserFromContacts(contact)"
									(click)="confirmNewUserFromContacts(contact)">
									<span class="fw-500 ellipsis" *ngIf="contact.name !== contact.email">{{contact.name}}</span>
									<span class="ellipsis">{{contact.email}}</span>
								</li>
							</ng-template>
						</auto-complete-menu>
					</div>

                    <a class="link-select" style="align-self: flex-start;" (click)="openAddressBookModal()">
                        Select from My Contacts
                    </a>
                </div>
            </div>
            <div class="flxClmn vSpace1">
                <div class="admin-panel-row">
                    <label style="vertical-align: unset;">Message</label>
					<div class="summernote-editor" id="summernote"
						 [ngxSummernote]="summernoteOptions"
						 [(ngModel)]="template.html">
					</div>
                </div>
				<div class="flxRow hSpace1 bs-enabled" style="align-items: baseline; padding-left: 65px;">
					<i class="far fa-info-circle text-info"></i>
					<span class="text-muted fw-500">Note: You can edit this message.</span>
				</div>
            </div>

			<div>
				<checkbox id="adminPermissions"
						  tooltipTxt="Once users are connected to the plan, they will be granted admin permissions"
						  [(model)]="addActiveUserPopup.adminPermissions">
					Admin Permissions
				</checkbox>
			</div>
        </div>
    </popup-c>

		<contact-address-book-c
			*ngIf="modalData?.openContactsAddressBook"
			[data]="modalData"
			[allContacts]="allContacts"
			[contacts]="users"
			(addCb)="confirmAddNewUserFromMyContacts($event.contacts)"
			(removeCb)="removeUser($event.contacts)">
		</contact-address-book-c>

    <!--Move user to Admin popup-->
    <popup-c class="overflownV" *ngIf="moveUserToAdminPopup && moveUserToAdminPopup.show"
           head="Move User to Plan"
           size="dynamic"
           (closeCb)="moveUserToAdminPopup = null"
           (confirmCb)="confirmMoveUserToAdmin()"
           [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: moveUserToAdminInProcess}}">
        <div class="flxClmn f-1-0 vSpace1" style="overflow: visible;">
            <span>Move <b>{{moveUserToAdminPopup.userToMove.name}}</b> from <b>{{moveUserToAdminPopup.oldAdmin.name}}</b> plan to another plan</span>
            <br/>
            <span>Select the new plan from the following list:</span>
            <app-dropdown-c style="width: 320px;"
                          [text]="moveUserToAdminPopup.selectedAdmin?.displayName || 'Select'"
                          [items]="moveUserToAdminPopup.adminsList"
                          itemDisplayKey="displayName" [enableSearch]="true"
                          (onItemClicked)="moveUserToAdminPopup.selectedAdmin = $event.item;"></app-dropdown-c>
        </div>
    </popup-c>

    <new-plan-wizard *ngIf="newPlanWizard" [data]="newPlanWizard"></new-plan-wizard>

    <!--Plan Security Settings popup-->
    <popup-c class="bs-enabled" *ngIf="accountConfigPopup?.show"
           head="Plan Security Settings"
           (closeCb)="accountConfigPopup = null"
           size="large">
        <div class="flxClmn f-1-0" style="overflow: auto;">

			<div class="simple-tab-row w100 flxRow">
				<ng-container *ngFor="let tab of accountConfigPopup.tabs | keyvalue: gs.returnZero">
					<div class="tab-header"
						 [ngClass]="{'chosen' : accountConfigPopup.activeTab === tab.value}"
						 (click)="accountConfigPopup.activeTab = tab.value">
						<span class="hvr-opacity">{{tab.value}}</span>
					</div>
				</ng-container>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="accountConfigPopup.activeTab === accountConfigPopup.tabs.login">
				<!--Settings: Password Expiration -->
				<div class="list-group-item settings-list-item">
					<div class="title-section-container flex-column gap-2">
						<b>Password Expiration</b>
						<span class="lh-base" style="font-size: 0.9em;">Enforce expiration on your users' passwords. Expiration will be enforced only for users under your verified domains:</span>
						<div class="flex-column gap-1 text-muted" style="max-height: 15vh; min-height: 85px; overflow: auto; background: #ffffffa1; padding: 5px;"
							 *ngIf="sharedPlanInfo.domains?.length">
							<ng-container *ngFor="let domain of sharedPlanInfo.domains; trackBy: gs.trackByIndex">
								<span *ngIf="domain.verified"
									  style="margin-left: 10px;">
									- {{domain.domain}}
								</span>
							</ng-container>
						</div>
						<span class="text-muted" *ngIf="!isAnyDomaimVerified" style="margin-left: 5px; margin-top: 10px; font-style: italic;">No verified domains</span>
					</div>

					<div class="content-container flex-column gap-2">
						<label class="radio-container hSpace05 m-0" [ngClass]="{'disabled-overlay' : !isUserDomaimVerified}">
							<input type="radio" name="accountPasswordExpiration"
								   [value]="false"
								   (ngModelChange)="accountConfigPopup.error = false;"
								   [(ngModel)]="accountConfigPopup.enforcePasswordExpiration.enabled"
								   [disabled]="!isUserDomaimVerified">
							<span class="checkmark"></span>
							<span>Passwords never expire</span>
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Passwords will never require changing"></i>
						</label>

						<label class="radio-container hSpace05 m-0" [ngClass]="{'disabled-overlay' : !isUserDomaimVerified}">
							<input type="radio" name="accountPasswordExpiration"
								   [value]="true"
								   (ngModelChange)="accountConfigPopup.error = false;"
								   [(ngModel)]="accountConfigPopup.enforcePasswordExpiration.enabled"
								   [disabled]="!isUserDomaimVerified">
							<span class="checkmark"></span>
							<span>Passwords expire after</span>
							<input [selectAllText]="selectExpirationTextFlag"
								   style="width: 65px; height: inherit; margin-bottom:0; box-sizing: border-box; border-radius: 4px; border: 1px solid #ccc; padding: 2px 8px; position: relative; opacity: 1; cursor: auto; margin: 0 3px;"
								   type="number"
								   [disabled]="!accountConfigPopup.enforcePasswordExpiration.enabled"
								   (ngModelChange)="accountConfigPopup.error = false;"
								   [(ngModel)]="accountConfigPopup.enforcePasswordExpiration.expiration_days" size="5"
								   placeholder="Days">
							<label style="vertical-align: unset;">Days</label>
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="After the set amount of days, passwords will expire and require changing to log in.<br/><b>Minimum expiration</b> is 10 days.<br/><b>Maximum expiration</b> is 365 days."></i>
						</label>

						<ng-container *ngIf="!isUserDomaimVerified">
							<br/>
							<span class="text-warning">{{dic.ERRORS.auth0RuleIdNoDomains}}</span>
						</ng-container>

						<btn-c [isDisabled]="accountConfigPopup.applyInProcess"
							   (action)="updateAccountExpiration();">
							Apply
						</btn-c>
					</div>

				</div>

				<!--Settings: Enforce log in methods -->
				<div class="list-group-item settings-list-item">
					<div class="title-section-container flex-column gap-2">
						<b>Enforce Login Methods</b>
						<span class="lh-base" style="font-size: 0.9em;">Select which login methods should be allowed for your users</span>
					</div>
					<div class="content-container flex-column gap-1">
						<label style="margin-bottom: 7px;" class="radio-container hSpace05">
							<input type="radio" name="enforceSSo" style="height: 0;"
								   [value]="false"
								   (ngModelChange)="accountConfigPopup.error = false;"
								   [(ngModel)]="accountConfigPopup.enforceLoginMethod">
							<span class="checkmark"></span>
							<span>Do not enforce login method</span>
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Users could use any authentication method to log in"></i>
						</label>

						<div class="flxRow hSpace2" style="align-items: center;">
							<label style="margin-bottom: 0; flex-basis: 250px; flex-shrink: 0;" class="radio-container hSpace05">
								<input type="radio" name="enforceSSo" style="height: 0;"
									   [value]="true"
									   (ngModelChange)="accountConfigPopup.error = false;"
									   [(ngModel)]="accountConfigPopup.enforceLoginMethod">
								<span class="checkmark"></span>
								<span>Allow only these login methods:</span>
								<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Users will only be able to log in using the selected methods"></i>
							</label>
							<app-dropdown-c class="f-1-0 expand-left" style="line-height: 1; max-width: 235px;"
											[error]="accountConfigPopup.error && accountConfigPopup.enforceLoginMethod && !_.some(accountConfigPopup.allowedLoginMethods, 'selected')"
											[items]="accountConfigPopup.allowedLoginMethods"
											[isDisabled]="!accountConfigPopup.enforceLoginMethod"
											[isMultipleSelection]="true"
											(onItemClicked)="accountConfigPopup.error = false;"
											itemDisplayKey="display">
							</app-dropdown-c>
						</div>

						<btn-c [isDisabled]="accountConfigPopup.applyInProcess"
							   (action)="updateAllowedLoginMethods();">
							Apply
						</btn-c>
					</div>

				</div>

				<!--Settings: Enforce log in MFA -->
				<div class="list-group-item settings-list-item">
					<div class="title-section-container flex-column gap-2">
						<b>Login MFA</b>
						<span class="lh-base" style="font-size: 0.9em;">Controls how multi-factor authentication (MFA) is applied to new users and Single Sign-On (SSO) logins.</span>
					</div>
					<div class="content-container flex-column gap-1">
						<div class="flex-row gap-1 align-items-center">
							<input id="enforce" type="checkbox"
								   [(ngModel)]="accountConfigPopup.mfa.enforce"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Enforce Login MFA for New Users</span>
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="MFA setting will be enforced on new users who join this plan, and they will not be able to disable it "></i>
						</div>

						<div class="flex-row gap-1 align-items-center">
							<input id="skip_mfa_for_sso" type="checkbox"
								   [(ngModel)]="accountConfigPopup.mfa.skip_mfa_for_sso"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Skip MFA for SSO Logins</span>
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Users who sign in via Single Sign-On (SSO) will not be prompted for multi-factor authentication"></i>
						</div>

						<btn-c [isDisabled]="accountConfigPopup.applyInProcess"
							   (action)="updateLoginMFA();">
							Apply
						</btn-c>
					</div>

				</div>

				<!--Settings: whitelist/blocklist coutries -->
				<div class="list-group-item settings-list-item">
					<div class="title-section-container flex-column gap-2">
						<b>Block User Login by Location</b>
						<span class="lh-base" style="font-size: 0.9em;">Block access to the application according to the location from which the login is performed</span>
					</div>
					<div class="content-container flex-column gap-1">
						<label style="margin-bottom: 7px;" class="radio-container hSpace05">
							<input type="radio" name="loginCountriesMethod" style="height: 0;"
								   [value]="loginCountriesMethods.all"
								   (ngModelChange)="accountConfigPopup.error = false;"
								   [(ngModel)]="accountConfigPopup.loginCountriesMethod">
							<span class="checkmark"></span>
							<span>Allow all countries</span>
						</label>

						<div class="flxRow hSpace2" style="align-items: center;">
							<label style="margin-bottom: 0; flex-basis: 250px; flex-shrink: 0;" class="radio-container hSpace05">
								<input type="radio" name="loginCountriesMethod" style="height: 0;"
									   [value]="loginCountriesMethods.allowlist"
									   (ngModelChange)="accountConfigPopup.error = false;"
									   [(ngModel)]="accountConfigPopup.loginCountriesMethod">
								<span class="checkmark"></span>
								<span>Allow only these countries:</span>
								<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Users will only be able to log in from within the selected countries"></i>
							</label>
							<app-dropdown-c class="f-1-0 show-above expand-left" style="--bs-dropdown-menu-max-height: 200px; max-width: 235px;"
											[items]="accountConfigPopup.countries.allowOnly" itemDisplayKey="name"
											[error]="accountConfigPopup.error && accountConfigPopup.loginCountriesMethod === loginCountriesMethods.allowlist && !_.some(accountConfigPopup.countries.allowOnly, 'selected')"
											[isDisabled]="accountConfigPopup.loginCountriesMethod !== loginCountriesMethods.allowlist"
											[isMultipleSelection]="true"
											(onItemClicked)="accountConfigPopup.error = false;"
											[showTitle]="_.filter(accountConfigPopup.countries.allowOnly, 'selected').length > 1"
											[enableSearch]="true">
							</app-dropdown-c>
						</div>

						<div class="flxRow hSpace2" style="align-items: center;">
							<label style="margin-bottom: 0; flex-basis: 250px;  flex-shrink: 0;" class="radio-container hSpace05">
								<input type="radio" name="loginCountriesMethod" style="height: 0;"
									   [value]="loginCountriesMethods.blocklist"
									   (ngModelChange)="accountConfigPopup.error = false;"
									   [(ngModel)]="accountConfigPopup.loginCountriesMethod">
								<span class="checkmark"></span>
								<span>Block only these countries:</span>
								<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Users will not be able to log in from within the selected countries, but from within every other country"></i>
							</label>
							<app-dropdown-c class="f-1-0 show-above expand-left" style="--bs-dropdown-menu-max-height: 200px; max-width: 235px;"
											[items]="accountConfigPopup.countries.blockOnly" itemDisplayKey="name"
											[error]="accountConfigPopup.error && accountConfigPopup.loginCountriesMethod === loginCountriesMethods.blocklist && !_.some(accountConfigPopup.countries.blockOnly, 'selected')"
											[isDisabled]="accountConfigPopup.loginCountriesMethod !== loginCountriesMethods.blocklist"
											[isMultipleSelection]="true"
											(onItemClicked)="accountConfigPopup.error = false;"
											[showTitle]="_.filter(accountConfigPopup.countries.blockOnly, 'selected').length > 1"
											[enableSearch]="true">
							</app-dropdown-c>
						</div>

						<btn-c [isDisabled]="accountConfigPopup.applyInProcess"
							   (action)="updateLoginCountries();">
							Apply
						</btn-c>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="accountConfigPopup.activeTab === accountConfigPopup.tabs.general">
				<div class="list-group-item settings-list-item py-4 pb-3" *ngIf="gs.showSupportMenu">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Restrict Support Access to Admins and Reviewers</b>
						<span class="lh-base" style="font-size: 0.9em;">When enabled, only admins and reviewers can access the support menu and open support tickets. When disabled, all users can access the support menu and open support tickets.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="restrict_support_to_admins_and_reviewers"
										 [hideText]="true"
										 [(model)]="sharedPlanInfo.restrict_support_to_admins_and_reviewers"
										 (onChange)="updateGeneralSettings('restrict_support_to_admins_and_reviewers')"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4 pb-3">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Idle Session Timeout</b>
						<span class="lh-base" style="font-size: 0.9em;">Set the maximum idle time (in minutes) before a user session is automatically terminated for security purposes.</span>
					</div>
					<div class="content-container">
						<div class="flex-row align-items-center gap-2">
							<input type="number" min="1"
								   style="width: 80px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
								   placeholder="Minutes"
								   [(ngModel)]="sharedPlanInfo.wa_idle_session_timeout">
							<btn-c style="min-width: 0;"
								   endIcon="far fa-check"
								   (action)="updateGeneralSettings('wa_idle_session_timeout')">
							</btn-c>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4 pb-3">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>"What's New" Email Notification</b>
						<span class="lh-base" style="font-size: 0.9em;">Admins and sub-admins in this plan will receive an automated "What's New" email notification whenever new features and enhancements are added to the Trustifi systems.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="send_whats_new_alert_notification"
										 [hideText]="true"
										 [(model)]="sharedPlanInfo.send_whats_new_alert_notification"
										 (onChange)="updateGeneralSettings('send_whats_new_alert_notification')"></toggle-switch-c>
					</div>
				</div>
			</div>

		</div>
    </popup-c>

    <!--Change User Settings popup-->
    <popup-c class="bs-enabled" *ngIf="changeUserSettingsPopup?.show"
           head="Change User Settings" subTitle="Update user {{changeUserSettingsPopup.user.email}}"
           (closeCb)="changeUserSettingsPopup.show = false"
           size="medium">
        <div class="flxClmn f-1-0" style="overflow: auto;">

			<div class="simple-tab-row w100 flxRow">
				<ng-container *ngFor="let tab of changeUserSettingsPopup.tabs | keyvalue: gs.returnZero">
					<div class="tab-header"
						 [ngClass]="{'chosen' : changeUserSettingsPopup.activeTab === tab.value}"
						 (click)="changeUserSettingsPopup.activeTab = tab.value">
						<span class="hvr-opacity">{{tab.value}}</span>
					</div>
				</ng-container>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.general">
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 4 0;">
						<b>User name</b>
					</div>
					<div class="content-container overflow-auto">
						<div *ngIf="!changeUserSettingsPopup.editName">
							{{changeUserSettingsPopup.user.name}}
							<i class="far fa-edit" style="cursor: pointer;" (click)="changeUserSettingsPopup.editName = {}"></i>
						</div>

						<div *ngIf="changeUserSettingsPopup.editName" class="flex-row gap-2">
							<input class="f-1-0" style="min-width: 0;" type="text" placeholder="First Name"
								   [(ngModel)]="changeUserSettingsPopup.editName.first"/>
							<input class="f-1-0" style="min-width: 0;" type="text" placeholder="Last Name"
								   [(ngModel)]="changeUserSettingsPopup.editName.last"/>

							<btn-c style="min-width: 0;" endIcon="zmdi zmdi-check"
								   [isDisabled]="!changeUserSettingsPopup.editName.first || !changeUserSettingsPopup.editName.last || changeUserSettingsPopup.inProcess"
								   (action)="updateUserName(changeUserSettingsPopup.user, changeUserSettingsPopup.editName.first, changeUserSettingsPopup.editName.last);">
							</btn-c>
							<btn-c style="min-width: 0;"
								   endIcon="zmdi zmdi-close" color="danger"
								   variant="text"
								   btnTooltip="Cancel edit"
								   (action)="changeUserSettingsPopup.editName = null;">
							</btn-c>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 4 0;">
						<b>Job Title</b>
						<span class="lh-base" style="font-size: 0.9em;">Job titles can be used with dynamic fields in Email Signatures</span>
					</div>
					<div class="content-container overflow-auto">
						<div *ngIf="!changeUserSettingsPopup.editJobTitle">
							{{changeUserSettingsPopup.user.job_title || 'N/A'}}
							<i class="far fa-edit" style="cursor: pointer;" (click)="changeUserSettingsPopup.editJobTitle = {name: changeUserSettingsPopup.user.job_title}"></i>
						</div>

						<div *ngIf="changeUserSettingsPopup.editJobTitle" class="flex-row gap-2">
							<input class="f-1-0" style="min-width: 0;" type="text" placeholder="Job"
								   [(ngModel)]="changeUserSettingsPopup.editJobTitle.name"/>

							<btn-c style="min-width: 0;" endIcon="zmdi zmdi-check"
								   [isDisabled]="!changeUserSettingsPopup.editJobTitle.name || changeUserSettingsPopup.inProcess"
								   (action)="updateUserJobTitle(changeUserSettingsPopup.user, changeUserSettingsPopup.editJobTitle.name);">
							</btn-c>
							<btn-c style="min-width: 0;"
								   endIcon="zmdi zmdi-close" color="danger"
								   variant="text"
								   btnTooltip="Cancel edit"
								   (action)="changeUserSettingsPopup.editJobTitle = null;">
							</btn-c>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 4 0;">
						<b>Time zone</b>
						<span class="lh-base" style="font-size: 0.9em;">
							This time zone will be used to show dates and times for reports sent by the system, such as quarantined email reports
						</span>
					</div>
					<div class="content-container">
						<div *ngIf="!changeUserSettingsPopup.editTimezone">
							{{changeUserSettingsPopup.currentTimezone?.label || 'N/A'}}
							<i class="far fa-edit" style="cursor: pointer;" (click)="changeUserSettingsPopup.editTimezone = true"></i>
						</div>

						<div *ngIf="changeUserSettingsPopup.editTimezone" class="flex-row gap-2">
							<app-dropdown-c class="show-above limit-height" style="width: 250px; --bs-dropdown-menu-max-height: 180px;"
											text="{{changeUserSettingsPopup.newTimezone?.label || 'Select'}}"
											[enableSearch]="true"
											itemDisplayKey="label"
											[items]="timeZones"
											(onItemClicked)="changeUserSettingsPopup.newTimezone = $event.item;"></app-dropdown-c>
							<btn-c style="min-width: 0;" endIcon="zmdi zmdi-check"
								   [isDisabled]="!changeUserSettingsPopup.newTimezone || changeUserSettingsPopup.inProcess"
								   (action)="updateUserTimeZoneExecute(changeUserSettingsPopup.user, changeUserSettingsPopup.newTimezone?.zone);">
							</btn-c>
							<btn-c style="min-width: 0;"
								   endIcon="zmdi zmdi-close" color="danger"
								   variant="text"
								   btnTooltip="Cancel edit"
								   (action)="changeUserSettingsPopup.editTimezone = null;">
							</btn-c>
						</div>
					</div>
				</div>

			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.mfa">
				<div class="list-group-item settings-list-item py-4 pb-3">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Enable Login MFA</b>
						<span class="lh-base" style="font-size: 0.9em;">The user will be required to perform multi-factor authentication when logging in to the Trustifi portal</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="enabled"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mfa.enabled"
										 [isDisabled]="changeUserSettingsPopup.mfa.strict"
										 (onChange)="toggleMFAForPlanUsersExecute(changeUserSettingsPopup.user, 'enabled', changeUserSettingsPopup.mfa.enabled)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4 pb-3">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Enforce Login MFA</b>
						<span class="lh-base" style="font-size: 0.9em;">The "Login MFA" setting will be enforced on the user, and they will not be able to disable it</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="strict"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mfa.strict"
										 (onChange)="toggleMFAForPlanUsersExecute(changeUserSettingsPopup.user, 'strict', changeUserSettingsPopup.mfa.strict)"></toggle-switch-c>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.advSetting">
				<div class="flex-column gap-2 overflow-auto">
					<div class="overflow-auto">
						<div class="flex-column gap-2 p-3" style="min-height: fit-content;">

							<span class="fw-500 mb-2">Email Security</span>
							<div class="flex-row w-100 justify-content-between gap-2 align-items-center">
								<div class="flex-row f-1-0 align-items-center gap-2">
									<span>Authentication method:</span>
									<app-dropdown-c class="f-1-0" style="max-width: 120px; height: 22px;"
													[text]="_.startCase(changeUserSettingsPopup.advanced.secure.method_2factor.value)">
										<li *ngFor="let method of dic.CONSTANTS.secureMethods"
											[id]="'AuthMethod' + method"
											(click)="changeUserSettingsPopup.advanced.secure.method_2factor.value = method; updateUserAdvEmailSettings(changeUserSettingsPopup.user)">
											{{_.startCase(method)}}
										</li>
									</app-dropdown-c>
								</div>
							</div>

							<div class="flex-column gap-2 ps-3" style="max-width: 264px; min-height: fit-content;"
								 *ngIf="changeUserSettingsPopup.advanced.secure.method_2factor.value === dic.CONSTANTS.authMethods.password">
								<div class="flex-row f-1-0 align-items-center gap-2">
									<span>Password:</span>
									<div class="position-relative f-1-0">
										<input id="method_2factor_password"
											   [type]="!changeUserSettingsPopup.showPassword ? 'password' : 'text'"
											   class="w-100" style="height: 22px;"
											   placeholder="Use default password"
											   (change)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
											   [(ngModel)]="changeUserSettingsPopup.advanced.secure.method_2factor_password.value"
											   [ngClass]="{'nofill': changeUserSettingsPopup.advanced.secure.method_2factor_password.value && !changeUserSettingsPopup.showPassword}">
										<label style="opacity: 0.35; position: absolute; top: 50%; right: 0; transform: translate(-60%,-50%);" class="hidepwd cursor-pointer hvr-darken">
											<input type="checkbox" [(ngModel)]="changeUserSettingsPopup.showPassword"/>
											<i class="fas fa-eye unchecked"></i>
											<i class="fas fa-eye-slash checked"></i>
										</label>
									</div>
								</div>
								<div class="flex-row f-1-0 align-items-center gap-2" *ngIf="changeUserSettingsPopup.advanced.secure.method_2factor.value === dic.CONSTANTS.authMethods.password">
									<span>Hint:</span>
									<div class="position-relative f-1-0">
										<input id="method_2factor_password"
											   type="text"
											   class="w-100" style="height: 22px;"
											   placeholder="Hint"
											   (change)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
											   [(ngModel)]="changeUserSettingsPopup.advanced.secure.method_2factor_password_hint.value">
									</div>
								</div>

								<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.use_contact_2factor_password.value',
														id: 'useContact2factorPassword',
														text: 'Use contact\'s password',
														tooltip: 'Use the contact\'s personal MFA password if one exists'}">
								</ng-container>

							</div>


							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.enable_smart_authentication.value',
														id: 'smartAuthentication',
														text: 'Enable Smart Authentication',
														tooltip: 'We will use a unique fingerprint signature to authenticate the recipient without the MFA step when possible while maintaining maximum security.'}">
							</ng-container>

							<div class="flex-row w-100 justify-content-between gap-2 align-items-center"
								 [ngClass]="{'disabled' : userInfo.plan.policy.expired_enable.strict}">
								<div class="flex-row f-1-0 align-items-center hSpace1">
									<toggle-switch-c id="expiresInXdays"
											  [isDisabled]="userInfo.plan.policy.expired_enable.strict"
													 [hideText]="true"
													 (onChange)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
											  [(model)]="changeUserSettingsPopup.advanced.secure.expired_enable.value">
									</toggle-switch-c>
									<label for="expiresInXdays">Expires in</label>

									<input id="expired_days" type="number"
										   [disabled]="userInfo.plan.policy.expired_enable.strict || !changeUserSettingsPopup.advanced.secure.expired_enable.value"
										   min="1" max="365"
										   class="mx-1" style="height: 22px; width: 55px;"
										   [(ngModel)]="changeUserSettingsPopup.advanced.secure.expired_days.value"
										   (ngModelChange)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
										   placeholder="Days" />
									<label for="expiresInXdays" style="margin: 0; position: relative;">
											<span style="pointer-events: none;">
												days
											</span>
									</label>
								</div>

								<div class="flex-row align-items-center gap-2">
									<i *ngIf="userInfo.plan.policy.expired_enable.strict" [tooltip]="userInfo.plan.policy.expired_enable.strict ? 'This option is locked by your plan admin' : 'Option can be enabled only for emails with &quot;Encrypt Message Content&quot; or &quot;Require Authentication&quot; enabled'" style="color:#818181; padding-left:5px;" class="zmdi zmdi-lock-outline animated fadeIn"></i>
									<i style="font-weight: 400;" class="far fa-question-circle" tooltip="<b>Enabled</b> - Sent email has access expiration.</br><b>Disabled</b> - Email never expires"></i>
								</div>
							</div>

							<div class="flex-row w-100 justify-content-between gap-2 align-items-center"
								 [ngClass]="{'disabled': userInfo.plan.policy.delete_attachment_enable.strict}">
								<div class="flex-row f-1-0 align-items-center hSpace1">
									<toggle-switch-c id="deleteAttachmentsInXdays"
											  [isDisabled]="userInfo.plan.policy.delete_attachment_enable.strict"
													 [hideText]="true"
													 (onChange)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
											  [(model)]="changeUserSettingsPopup.advanced.secure.delete_attachment_enable.value">
									</toggle-switch-c>
									<label for="deleteAttachmentsInXdays">Delete attachments in</label>
									<input id="expired_days" type="number"
										   [disabled]="userInfo.plan.policy.delete_attachment_enable.strict || !changeUserSettingsPopup.advanced.secure.delete_attachment_enable.value"
										   min="1" max="365"
										   class="mx-1" style="height: 22px; width: 55px;"
										   [(ngModel)]="changeUserSettingsPopup.advanced.secure.delete_attachment_days.value"
										   (ngModelChange)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
										   placeholder="Days" />
									<label for="deleteAttachmentsInXdays" style="margin: 0; position: relative;">
										<span style="pointer-events: none;">
											days
										</span>
									</label>
								</div>

								<div class="flex-row align-items-center gap-2">
									<i *ngIf="userInfo.plan.policy.delete_attachment_enable.strict" [tooltip]="userInfo.plan.policy.delete_attachment_enable.strict ? 'This option is locked by your plan admin' : 'Option can be enabled only for emails with attachments'" style="color:#818181; padding-left:5px;" class="zmdi zmdi-lock-outline animated fadeIn"></i>
									<i style="font-weight: 400;" class="far fa-question-circle" tooltip="<b>Enabled</b> - Attachments will be deleted according to the expiration date</br><b>Disabled</b> - Attachments will never be deleted"></i>
								</div>
							</div>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.enforce_attachment_encryption.value',
														id: 'enforceAttachmentEncryption',
														text: 'Enforce attachment encryption',
														tooltip: 'Attachments will be encrypted regardless of the configured policy'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.attachments_preview_mode.value',
														id: 'attachments_preview_mode',
														text: 'Attachments preview only mode',
														tooltip: 'Recipients will only be able to preview attachments and will not be able to download them. Note that not all file types are supported for preview.'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.enable_print.value',
														id: 'allowPrint',
														text: 'Allow print',
														tooltip: '<b>Enabled</b> - Recipient can print email.</br><b>Disabled</b> - Recipient cannot print email'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.secure_received.value',
														id: 'authOnReplies',
														text: 'Require Authentication on replies',
														tooltip: '<b>Enabled</b> - Opening recipient reply will require authentication from sender.</br><b>Disabled</b> - Sender authentication is not required'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.secure.open_only_once.value',
														id: 'accessOnlyOnce',
														text: 'Allow email access only once',
														tooltip: '<b>Enabled</b> - Recipient can access the decrypted data only once.</br><b>Disabled</b> - Recipient has access to encrypted the data until it reached the expiration date'}">
							</ng-container>

							<br/>
							<span class="fw-500 mb-2">General</span>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.email_me.on_any_opened.value',
														id: 'notifyEmailOpened',
														text: 'Notify me about emails opened',
														tooltip: '<b>Enabled</b> - Notification will be sent via email on any email opening.</br><b>Disabled</b> - Opening notification will be turned off.'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.email_me.on_link_clicked.value',
														id: 'notifyLinksClicked',
														text: 'Notify me about links clicked',
														tooltip: 'An email notification will be sent for any link clicked'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.email_me.on_attachment_download.value',
														id: 'notifyFilesDownloaded',
														text: 'Notify me about files downloaded',
														tooltip: 'An email notification will be sent for any file downloaded'}">
							</ng-container>

							<div class="flex-row w-100 justify-content-between gap-2 align-items-center">
								<div class="flxRow-start f-1-0 hSpace1" style="align-items: center;">
									<toggle-switch-c id="reply_to_enable"
													 [hideText]="true"
													 (onChange)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
											  [(model)]="changeUserSettingsPopup.advanced.general.reply_to_enable.value">
									</toggle-switch-c>
									<label for="reply_to_enable">Reply to</label>
									<input id="reply_to_email" type="text" class="m-0 ms-2 f-1-0" style="max-width: 180px; height: 22px;"
										   *ngIf="changeUserSettingsPopup.advanced.general.reply_to_enable.value"
										   placeholder="My Email"
										   (change)="updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
										   [ngClass]="{'validation-error' : changeUserSettingsPopup.advanced.general.reply_to_enable.value && changeUserSettingsPopup.advanced.general.reply_to_email.value ? !gs.validateEmail(changeUserSettingsPopup.advanced.general.reply_to_email.value) : false}"
										   [(ngModel)]="changeUserSettingsPopup.advanced.general.reply_to_email.value"/>
									<input type="text" class="m-0 ms-2 f-1-0" style="max-width: 180px; height: 22px;"
										   *ngIf="!changeUserSettingsPopup.advanced.general.reply_to_enable.value"
										   [disabled]="true"
										   [placeholder]="'do-not-reply@' + gs.domain"/>
								</div>
								<div class="flex-row align-items-center gap-2">
									<i style="font-weight: 400;" class="far fa-question-circle" tooltip="<b>Enabled</b> - Allow replies to the sender email address or any other address.</br><b>Disabled</b> - Do not allow replies"></i>
								</div>
							</div>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.general.trustifi_wrapper.value',
														id: 'useTemplate',
														text: 'Use Default Template',
														tooltip: '<b>Enabled</b> - Email uses default template.</br><b>Disabled</b> - No template used.'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.general.track_links.value',
														id: 'trackLinks',
														text: 'Track links',
														tooltip: '<b>Enabled</b> - Track email content link clicks.</br><b>Disabled</b> - Don’t track email content link clicks.'}">
							</ng-container>


							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.general.multi_replies.value',
														id: 'unlimitedReplies',
														text: 'Unlimited replies',
														tooltip: '<b>Enabled</b> - Recipient will be able to send unlimited replies.</br><b>Disabled</b> - Recipient will be able to send only one reply.'}">
							</ng-container>

							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.general.enforce_reply_all.value',
														id: 'enforceReplyAll',
														text: 'Enforce reply all',
														tooltip: 'Ensures that when someone receives an email and chooses to reply, their response is sent to all the original recipients of the email'}">
							</ng-container>


							<ng-container *ngTemplateOutlet="advancedOptionTemplate;
											  context: {modelRef: 'advanced.general.allow_download_as_eml.value',
														id: 'allowDownloadEml',
														text: 'Allow downloading as EML',
														tooltip: 'When enabled, recipients will be able to download the email as EML.'}">
							</ng-container>




							<ng-template #advancedOptionTemplate let-id="id" let-modelRef="modelRef" let-text="text" let-tooltip="tooltip" let-isLocked="isLocked" let-lockedTooltip="lockedTooltip" let-isDisabled="isDisabled">
								<div class="flex-row w-100 justify-content-between gap-2 align-items-center">
									<toggle-switch-c [id]="id"
										[isDisabled]="isDisabled"
										[hideText]="true"
										(modelChange)="_.set(changeUserSettingsPopup, modelRef, $event); updateUserAdvEmailSettings(changeUserSettingsPopup.user)"
										[model]="_.get(changeUserSettingsPopup, modelRef)">
									</toggle-switch-c>
									<label [for]="id" class="f-1-0">{{text}}</label>
									<div class="flex-row align-items-center gap-2">
										<i style="font-weight: 400;" class="far fa-question-circle" [tooltip]="tooltip"></i>
									</div>
								</div>
							</ng-template>
						</div>
					</div>
				</div>
			</div>
		</div>

    </popup-c>

	<!--Set User Timezone popup-->
    <popup-c class="overflownV bs-enabled" *ngIf="setUserTimezonePopup?.show"
            head="Set User Time Zone"
			subTitle="Set a time zone for <b>{{setUserTimezonePopup.users.length > 1 ? setUserTimezonePopup.users.length + ' users' : (setUserTimezonePopup.users[0].name || setUserTimezonePopup.users[0].email)}}</b>"
            (closeCb)="setUserTimezonePopup.show = false"
            (confirmCb)="setUserTimezonePopup.confirmCb();"
            [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: setUserTimezonePopup.setTimezoneInProcess}}"
            size="dynamic">
        <div class="flxClmn f-1-0 vSpace2" style="overflow: visible;">
			<div class="flex-column gap-3">
				<div class="flex-row align-items-center gap-2 flex-shrink-0"
					 *ngIf="setUserTimezonePopup.currentTimezone">
					<span style="flex-basis: 120px; flex-shrink: 0;">Current time zone:</span>
					<span class="fw-bold">{{setUserTimezonePopup.currentTimezone.label}}</span>
				</div>
				<div class="flex-row align-items-center gap-2">
					<span style="flex-basis: 120px; flex-shrink: 0;">New time zone:</span>
					<app-dropdown-c style="width: 250px;"
									text="{{setUserTimezonePopup.newTimezone?.label || 'Select'}}"
									[enableSearch]="true"
									itemDisplayKey="label"
									[items]="timeZones"
									(onItemClicked)="setUserTimezonePopup.newTimezone = $event.item;"></app-dropdown-c>
				</div>
			</div>
			<br/>
			<div class="flex-row align-items-center gap-3">
				<i class="far fa-info-circle text-info"></i>
				<span style="font-size: 12px;">This time zone will be used to show dates and times for reports sent by the system, such as quarantined email reports</span>
			</div>
        </div>
    </popup-c>


	<groups-popup-c
		*ngIf="showGroups"
		(cancelCb)="showGroups = false"
		[showActions]="true"
		[popupTitle]="'Groups'">
	</groups-popup-c>

	<aliases-popup-c *ngIf="showAliases"
			   (cancelCb)="getMailboxesAliases(false)"
			   [popupTitle]="'Mailboxes Aliases'"
			   [showActions]="true">
	</aliases-popup-c>


	<popup-c *ngIf="userPermissionPopup?.show"
		   head="Modify Permissions"
		   class="bs-enabled"
		   subTitle="Configure access permissions for the user {{userPermissionPopup.userObj.email}}"
		   (closeCb)="userPermissionPopup = null;"
		   size="large">
		<div class="flxClmn f-1-0" style="overflow: auto;">
			<div class="simple-tab-row w100 flxRow">
				<ng-container *ngFor="let tab of userPermissionPopup.tabs | keyvalue: gs.returnZero">
					<div class="tab-header"
						 [ngClass]="{'chosen' : userPermissionPopup.activeTab === tab.value}"
						 (click)="userPermissionPopup.activeTab = tab.value">
						<span class="hvr-opacity">{{tab.value}}</span>
					</div>
				</ng-container>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="userPermissionPopup.activeTab === userPermissionPopup.tabs.adminPermissions">
				<span style="margin-top: 5px;">Controls global admin level permissions for your own Trustifi plan.</span>
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Grant admin permissions to user</b>
						<span class="lh-base" style="font-size: 0.9em;">Admin permissions empower the user to navigate through and modify the complete plan configuration across all pages</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="isSubAdmin"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.isSubAdmin"
										 (onChange)="modifyUserPermissionsExecute()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Read only permissions</b>
						<span class="lh-base" style="font-size: 0.9em;">Admin will have read-only access with no ability to make changes</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="readOnlyAdmin"
										 [hideText]="true"
										 [isDisabled]="!userPermissionPopup.isSubAdmin"
										 [(model)]="userPermissionPopup.readOnly"
										 (onChange)="modifyUserReadOnlyExecute()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" *ngIf="sharedPlanInfo.customer_id">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Multi tenant view</b>
						<span class="lh-base" style="font-size: 0.9em;">Admin will have access to the multi-tenant selector, which allows them to directly access managed plans and clients</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="show_multi_tenant"
										 [hideText]="true"
										 [isDisabled]="!userPermissionPopup.isSubAdmin || userPermissionPopup.managed_plans_only"
										 [(model)]="userPermissionPopup.show_multi_tenant"
										 (onChange)="modifyUserMultiTenantViewExecute()"></toggle-switch-c>
					</div>
				</div>

				<!--CC: technician role (partner plans only) - admin on managed plans only-->
				<div class="list-group-item settings-list-item py-4" *ngIf="sharedPlanInfo.customer_id">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Technician (managed plans only)</b>
						<span class="lh-base" style="font-size: 0.9em;">Admin permissions apply to managed plans only: the user can provision plans, manage them through the multi-tenant view and copy policies, but has no admin access to your own plan</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="managed_plans_only"
										 [hideText]="true"
										 [isDisabled]="!userPermissionPopup.isSubAdmin"
										 [(model)]="userPermissionPopup.managed_plans_only"
										 (onChange)="modifyUserManagedPlansOnlyExecute()"></toggle-switch-c>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="userPermissionPopup.activeTab === userPermissionPopup.tabs.planReviewer">
				<span style="margin-top: 5px;">Controls reviewer-level permissions for different modules of your own Trustifi plan. Granting reviewer-level permissions to a user will override the "read only" setting for that module only.</span>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Outbound reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will receive notifications about quarantined email threats sent by your protected mailboxes and will be able to take immediate actions</span>
					</div>
					<div class="content-container">
						<div class="flex-row justify-content-between">
							<toggle-switch-c id="isOutboundReviewer"
											 [hideText]="true"
											 [(model)]="userPermissionPopup.isOutboundReviewer"
											 (onChange)="modifyUserReviewerExecute('outbound')"></toggle-switch-c>
							<a class='blue-link' target='_self' href='outbound/adminPolicyManagement/reviewers'>View more settings</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Inbound Shield reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will receive notifications about quarantined email threats sent to your protected mailboxes and will be able to take immediate actions</span>
					</div>
					<div class="content-container">
						<div class="flex-row justify-content-between">
							<toggle-switch-c id="isInboundReviewer"
											 [hideText]="true"
											 [(model)]="userPermissionPopup.isInboundReviewer"
											 (onChange)="modifyUserReviewerExecute('inbound')"></toggle-switch-c>
							<a class='blue-link' target='_self' href='inbound/inboundShield/reviewers'>View more settings</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Archive reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers who will have access to archive information</span>
					</div>
					<div class="content-container">
						<div class="flex-row justify-content-between">
							<toggle-switch-c id="isArchiveReviewer"
											 [hideText]="true"
											 [(model)]="userPermissionPopup.isArchiveReviewer"
											 (onChange)="modifyUserReviewerExecute('archive')"></toggle-switch-c>
							<a class='blue-link' target='_self' href='archive/configurations/reviewers'>View more settings</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Threat Simulation reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to all Threat Simulation pages, and will be able to send Threat Simulation campaigns and view campaign metrics</span>
					</div>
					<div class="content-container">
						<div class="flex-row justify-content-between">
							<toggle-switch-c id="isThreatSimulationReviewer"
											 [hideText]="true"
											 [(model)]="userPermissionPopup.isThreatSimulationReviewer"
											 (onChange)="modifyUserReviewerExecute('threat_simulation')"></toggle-switch-c>
							<a class='blue-link' target='_self' href='threatSimulation/configuration/reviewers'>View more settings</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Account Takeover reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to information regarding Account Takeover incidents and will receive notifications for such incidents</span>
					</div>
					<div class="content-container">
						<div class="flex-row justify-content-between">
							<toggle-switch-c id="isAcpReviewer"
											 [hideText]="true"
											 [(model)]="userPermissionPopup.isAcpReviewer"
											 (onChange)="modifyUserReviewerExecute('account_compromised')"></toggle-switch-c>
							<a class='blue-link' target='_self' href='accountCompromised/configurations/reviewers'>View more settings</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Collaboration Protection reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to information regarding Collaboration Protection and will receive notifications for such incidents</span>
					</div>
					<div class="content-container">
						<div class="flex-row justify-content-between">
							<toggle-switch-c id="isCollabReviewer"
							                 [hideText]="true"
							                 [(model)]="userPermissionPopup.isCollabReviewer"
							                 (onChange)="modifyUserReviewerExecute('collaboration_protection')"></toggle-switch-c>
							<a class='blue-link' target='_self' href='collaborationProtection/configuration/reviewers'>View more settings</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" *ngIf="sharedPlanInfo.customer_id">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Partner reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to partner information</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="isPartnerReviewer"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.isPartnerReviewer"
										 (onChange)="modifyUserReviewerExecute('partner')"></toggle-switch-c>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="userPermissionPopup.activeTab === userPermissionPopup.tabs.globalReviewer">
				<span style="margin-top: 5px;">Controls reviewer-level permissions for different modules for all tenants under your partner-ID.</span>
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Allow reviewer permissions for the reviewer's own plan</b>
						<span class="lh-base" style="font-size: 0.9em;">The reviewer will have access to data and can perform actions on their own plan. If disabled, the reviewer can only access other plans under this partner-ID</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="allow_review_access_main_plan"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.userObj.global_reviewer.allow_review_access_main_plan"
										 (onChange)="updateUserGlobalReviewerExecute('general')"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Inbound Shield reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers can view quarantined emails for all of your managed plans and clients, as well as take actions</span>
					</div>
					<div class="content-container flex-column gap-2">
						<toggle-switch-c id="isGlobalInboundReviewer"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.userObj.global_reviewer.inbound.enabled"
										 (onChange)="updateUserGlobalReviewerExecute('inbound')"></toggle-switch-c>
						<div class="flex-column gap-2"
							 [ngClass]="{'disabled-overlay' : !userPermissionPopup.userObj.global_reviewer.inbound.enabled}">
							<div class="flex-row gap-2 align-items-center justify-content-between">
								<span>Allow this reviewer to release malicious emails</span>
								<toggle-switch-c id="reviewer_allow_release_malicious"
												 [hideText]="true"
												 [isDisabled]="!userPermissionPopup.userObj.global_reviewer.inbound.enabled"
												 [(model)]="userPermissionPopup.userObj.global_reviewer.inbound.reviewer_allow_release_malicious"
												 (onChange)="updateUserGlobalReviewerExecute('inbound')"></toggle-switch-c>
							</div>
							<div class="flex-row gap-2 align-items-center justify-content-between">
								<span>Allow this reviewer to view quarantine email content</span>
								<toggle-switch-c id="allow_view_content"
												 [hideText]="true"
												 [isDisabled]="!userPermissionPopup.userObj.global_reviewer.inbound.enabled"
												 [(model)]="userPermissionPopup.userObj.global_reviewer.inbound.allow_view_content"
												 (onChange)="updateUserGlobalReviewerExecute('inbound')"></toggle-switch-c>
							</div>
							<div class="flex-row gap-2 align-items-center justify-content-between">
								<span>Allow this reviewer to change configurations and settings</span>
								<toggle-switch-c id="inbound_allow_change_configuration"
												 [hideText]="true"
												 [isDisabled]="!userPermissionPopup.userObj.global_reviewer.inbound.enabled"
												 [(model)]="userPermissionPopup.userObj.global_reviewer.inbound.allow_change_configuration"
												 (onChange)="updateUserGlobalReviewerExecute('inbound')"></toggle-switch-c>
							</div>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Outbound reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to outbound setting, rules, and policies for all of your managed plans and clients</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="isGlobalOutboundReviewer"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.userObj.global_reviewer.outbound.enabled"
										 (onChange)="updateUserGlobalReviewerExecute('outbound')"></toggle-switch-c>
						<div class="flex-column gap-2"
							 [ngClass]="{'disabled-overlay' : !userPermissionPopup.userObj.global_reviewer.outbound.enabled}">
							<div class="flex-row gap-2 align-items-center justify-content-between">
								<span>Allow this reviewer to view quarantine email content</span>
								<toggle-switch-c id="allow_view_content_outbound"
												 [hideText]="true"
												 [isDisabled]="!userPermissionPopup.userObj.global_reviewer.outbound.enabled"
												 [(model)]="userPermissionPopup.userObj.global_reviewer.outbound.allow_view_content"
												 (onChange)="updateUserGlobalReviewerExecute('outbound')"></toggle-switch-c>
							</div>
							<div class="flex-row gap-2 align-items-center justify-content-between">
								<span>Allow this reviewer to change configurations and settings</span>
								<toggle-switch-c id="outbound_allow_change_configuration"
												 [hideText]="true"
												 [isDisabled]="!userPermissionPopup.userObj.global_reviewer.outbound.enabled"
												 [(model)]="userPermissionPopup.userObj.global_reviewer.outbound.allow_change_configuration"
												 (onChange)="updateUserGlobalReviewerExecute('outbound')"></toggle-switch-c>
							</div>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Archive reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers who will have access to archive information</span>
					</div>
					<div class="content-container flex-column gap-2">
						<toggle-switch-c id="isGlobalArchiveReviewer"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.userObj.global_reviewer.archive.enabled"
										 (onChange)="updateUserGlobalReviewerExecute('archive')"></toggle-switch-c>
						<div class="flex-column gap-2"
							 [ngClass]="{'disabled-overlay' : !userPermissionPopup.userObj.global_reviewer.archive.enabled}">
							<div class="flex-row gap-2 align-items-center justify-content-between">
								<span>Allow this reviewer to view archived email content</span>
								<toggle-switch-c id="allow_view_content_archive"
												 [hideText]="true"
												 [isDisabled]="!userPermissionPopup.userObj.global_reviewer.archive.enabled"
												 [(model)]="userPermissionPopup.userObj.global_reviewer.archive.allow_view_content"
												 (onChange)="updateUserGlobalReviewerExecute('archive')"></toggle-switch-c>
							</div>
						</div>

					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Threat Simulation reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to all Threat Simulation pages, and will be able to send Threat Simulation campaigns and view campaign metrics</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="isGlobalThreatSimulationReviewer"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.userObj.global_reviewer.threat_simulation.enabled"
										 (onChange)="updateUserGlobalReviewerExecute('threat_simulation')"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Set as Account Takeover reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Reviewers will have access to information regarding Account Takeover incidents and will receive notifications for such incidents</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="isGlobalAcpReviewer"
										 [hideText]="true"
										 [(model)]="userPermissionPopup.userObj.global_reviewer.account_compromised.enabled"
										 (onChange)="updateUserGlobalReviewerExecute('account_compromised')"></toggle-switch-c>
					</div>
				</div>
			</div>

		</div>
	</popup-c>
</div>

<popup-c *ngIf="userMfaPopup?.show"
		 head="Modify Login MFA Permissions"
		 class="bs-enabled"
		 size="small"
		 (closeCb)="userMfaPopup = null;">

	<div class="flxClmn gap-4">
		<div class="flxRow hSpace2">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Enable Login MFA</b>
				<span>The selected users will be required to perform multi-factor authentication when logging in to the Trustifi portal.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="enabled"
								 [hideText]="true"
								 [(model)]="userMfaPopup.enabled"
								 [isDisabled]="userMfaPopup.strict"
								 (onChange)="userMfaPopup.doneCb('enabled')"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow hSpace2">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Enforce Login MFA</b>
				<span>The "Login MFA" setting will be enforced on the selected users, and they will not be able to disable it.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="strict"
								 [hideText]="true"
								 [(model)]="userMfaPopup.strict"
								 (onChange)="userMfaPopup.doneCb('strict')"></toggle-switch-c>
			</div>
		</div>
	</div>
</popup-c>

<popup-c *ngIf="suppressionPopup?.show"
		 head="Suppression List"
		 subTitle="The list below shows the suppression status for each of your users. A 'True' indication means the user is on the email suppression list (usually due to previous bounces or spam complaints), and as a result cannot receive emails sent via Trustifi"
		 class="bs-enabled"
		 size="medium"
		 (closeCb)="suppressionPopup = null;">

	<div class="flxClmn vSpace3 f-1-0" style="overflow: auto;">
		<!--CC: progress indication - users are checked 1-by-1 due to rate limit-->
		<div class="flxClmn vSpace05" *ngIf="suppressionPopup.inProcess">
			<div class="flxRow" style="justify-content: space-between; align-items: center;">
				<span><i class="far fa-spinner fa-spin"></i> Checking suppression status...</span>
				<span>{{suppressionPopup.checkedCount}} / {{suppressionPopup.totalCount}} users</span>
			</div>
			<div style="height: 6px; width: 100%; background: #e0e0e0; border-radius: 3px; overflow: hidden;">
				<div style="height: 100%; background: royalblue; transition: width 0.3s ease;"
					 [style.width.%]="suppressionPopup.progressPercent"></div>
			</div>
		</div>
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="suppressionPopup.users"
			[headers]="[
				{text: 'Email', sortKey: 'email'},
				{text: 'Suppressed', sortKey: 'is_suppressed'},
			]"
			[cellsPrototype]="[
				{textKey: 'email'},
				{html: 'suppressedCell'},
			]"
			(searchFunction)="suppressionPopup.search($event.searchTerm, $event.activeFilters)"
			[options]="{
				itemsNameSingular: 'user',
				defaultSortKey: '-email'
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--incident type cells-->
				<span *ngIf="cellId === 'suppressedCell'" [ngStyle]="{color: item.is_suppressed ? 'red' : 'green'}">
					{{item.is_suppressed}}
				</span>
			</ng-template>
		</trustifi-table-c>
	</div>
</popup-c>

